export const selectUser = ({user}) => user || {};
export const selectUserName = (state) => selectUser(state).name;
export const selectUserFirstName = (state) => {
  const name = selectUser(state).name || '';
  return name.trim().split(/\s+/)[0] || '';
};

export const selectUserLastName = (state) => {
  const name = selectUser(state).name || '';
  const parts = name.trim().split(/\s+/);
  return parts.length > 1 ? parts[parts.length - 1] : '';
};
